import React, { memo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { FormButton } from "@app/components/Form/FormButton"

import type { ProductVariantProps } from "@root/types/global"

type Props = {
  activeVariant: ProductVariantProps | null
  handleErrors: () => void
  handleToggle: () => void
}

export const ProductStockToggle: React.FC<Props> = memo(({ activeVariant, handleErrors, handleToggle }) => {
  const { product } = useStaticQuery<GatsbyTypes.ProductStockToggleQuery>(graphql`
    query ProductStockToggle {
      product: sanityTemplateProduct {
        additionalStock
      }
    }
  `)

  return (
    <FormButton
      onClick={activeVariant?.sku ? handleToggle : handleErrors}
      size="md"
      title={product?.additionalStock}
      aria-label={product?.additionalStock}
      variant="pdpFindInStore"
      w="100%"
    >
      {product?.additionalStock}
    </FormButton>
  )
})
